/**
 * Choose the correct backend url by looking at the user's hostname
 *
 * @return {string} backend url
 */
export default function domain() {
  if (window.location.hostname === "apps.filtpod.com" || window.location.hostname === "apps.kynzo.io") {
    return "https://server1.kynzo.io/";
  } else if (
    window.location.hostname === "kynzo-test.web.app" ||
    window.location.hostname === "kynzo-test.firebaseapp.com"
  ) {
    return "https://server1.kynzo.io/";
  } else {
    return process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/";

  }
}
